import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../Security/firebase-config';
import {attendanceRequestMessage} from '../../shared/calendarNotification';
import EventNotificationContent from './EventNotificationContent';

export default function ParticipationRequestContent({ notification, onRespond, onNavigate }) {
  const payload = notification.payload || {};
  const teamId = notification.teamId || payload.teamId;
  const requestId = notification.requestId || payload.requestId || payload.id || payload.request?.id;
  const [request, setRequest] = useState(null);
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    setRequest(null);
    setAvailable(false);
    if (!teamId || !requestId) return undefined;
    return onSnapshot(doc(db, 'teams', teamId, 'participationRequests', requestId), snapshot => {
      setRequest(snapshot.exists() ? snapshot.data() : null);
      setAvailable(snapshot.exists());
    }, () => setAvailable(false));
  }, [teamId, requestId]);
  const details = {teamName: notification.teamName, ...payload, ...request};
  const response = [request?.status, notification.response, notification._respondedWith, payload.requestStatus]
    .find(value => value === 'accepted' || value === 'declined');
  const superseded = request?.status === 'superseded' || (!available && payload.requestStatus === 'superseded');
  return <div className="participation-request-details">
    <EventNotificationContent message={attendanceRequestMessage(details)} url={payload.url} onNavigate={onNavigate}>
    {superseded ? <p role="status">This request is no longer needed. Availability or event details changed.</p> : response ? <p role="status">You {response} this request.</p> : available ? <div className="notification-actions">
      {['accepted', 'declined'].map(value => <button key={value} type="button"
        className={`notif-action-btn ${value === 'accepted' ? 'accept' : 'decline'}`}
        disabled={!!notification._responding}
        onClick={event => { event.preventDefault(); event.stopPropagation(); onRespond(notification, value); }}>
        {value === 'accepted' ? 'Accept' : 'Decline'}
      </button>)}
      {notification._responding && <span role="status">Sending response…</span>}
    </div> : <p>This request is loading or no longer available.</p>}
    </EventNotificationContent>
  </div>;
}
